/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { t } from 'i18next';
import moment from 'moment';
import { Button, Dropdown, Image, Upload, notification } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import IconEmpty from '../../../../assets/Images/icons/empty';
import XflowComponent from '../../../../components/xflow';
import { ROUTER } from '../../../../constants/router';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import DataFlowService from '../../../../services/DataFlow.service';
import useNotify from '../../../../context/Notification/useNotify';
import IconConfirmeWarning from '../../../../assets/Images/icons/icon-warning';
import GlobalService from '../../../../services/Global.service';
import { DownloadOutlined } from '@ant-design/icons';
import ModalDelete from '../../../../components/Shared/modal/delete';
import Draw from '../../Draw';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab6 = ({
    detail,
    getDataFlowDetail,
    editMode,
    isView,
    dataFlowInfo,
    isNoPermission
}) => {
    const dataDiagram = detail?.dataDiagram;
    const navigate = useNavigate();
    const { businessProcessId } = useParams();

    const notify = useNotify();
    const [graphData, setGraphData] = useState();
    const [openImageChange, setOpenImageChange] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [typeOpen, setTypeOpen] = useState('image');
    const [fileList, setFileList] = useState([]);
    const [image, setImage] = useState('');
    const refUpload = useRef();
    const [openConfirmGenerate, setOpenConfirmGenerate] = useState(false);
    const [openConfirmClose, setOpenConfirmClose] = useState(false);

    const [action, setAction] = useState('');

    const isNotEnoughData = useCallback(() => {
        if (detail) {
            const {
                categoryPersonalData,
                collectData,
                collectDataDestruction,
                referenceDocuments,
            } = detail;
            return !(
                categoryPersonalData &&
                collectData &&
                collectDataDestruction &&
                referenceDocuments?.length > 0
            );
        }
        return true;
    }, [detail]);

    useEffect(() => {
        if (dataDiagram?.jsonData) {
            setGraphData(JSON.parse(dataDiagram?.jsonData));
        } else {
            setGraphData(null);
        }
    }, [dataDiagram?.jsonData]);

    const updateIsGenerateDataFlow = useCallback(
        async (isGenerateDataFlow) => {
            try {
                const { data } = await DataFlowService.updateIsGenerateDataFlow(
                    {
                        businessProcessId,
                        isGenerateDataFlow,
                    }
                );
                if (data?.resultCode === 1) {
                    getDataFlowDetail(businessProcessId);
                    setOpenConfirmGenerate(false);
                }
            } catch (error) {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        },
        [businessProcessId]
    );

    const items = [
        {
            label: t('Upload image'),
            key: '1',
            className: 'py-2',
            onClick: () => {
                setAction('upload');
                if (detail?.isGenerateDataFlow) {
                    setOpenConfirmGenerate(true);
                } else if (graphData || dataDiagram?.fileStorageId) {
                    setOpenImageChange(true);
                    setTypeOpen('image');
                } else {
                    refUpload.current.click();
                }
            },
        },
        {
            label: t('Draw diagram'),
            key: '2',
            className: 'py-2',
            onClick: () => {
                setAction('draw');
                if (detail?.isGenerateDataFlow) {
                    setOpenConfirmGenerate(true);
                } else if (graphData || dataDiagram?.fileStorageId) {
                    setOpenImageChange(true);
                    setTypeOpen('diagram');
                } else {
                    navigate(
                        `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/edit-flow`
                    );
                }
            },
        },
        {
            label: t('Generate Flow'),
            key: '3',
            className: 'py-2',
            onClick: () => {
                setAction('generate');
                if (isNotEnoughData()) {
                    setOpenConfirmClose(true);
                    return;
                }
                if (graphData || dataDiagram?.fileStorageId) {
                    setOpenConfirmGenerate(true);
                } else updateIsGenerateDataFlow(true);
            },
        },
    ];

    const onSave = async (fileStorageId) => {
        let payload = {
            businessProcessId: businessProcessId,
            jsonData: '',
            fileStorageId,
        };
        try {
            const { data } = await DataFlowService.updateTab6(payload);
            if (data?.resultCode === 1) {
                getDataFlowDetail(businessProcessId);
                notify({
                    title: t('common.Success'),
                    description: t('common.SaveData'),
                });
                setOpenConfirmDelete(false);
                setOpenImageChange(false);
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirmDelete(false);
            setOpenImageChange(false);
        }
    };

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            notification['error']({
                message: t('COOKIE.YouUploadFile'),
            });
        }
        const isLt10M = file.size < 10000000;
        if (!isLt10M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller10'),
            });
        }
        return isJpgOrPng && isLt10M;
    };

    const uploadProps = {
        multiple: false,
        listType: 'picture-card',
        beforeUpload,
        className: 'policy',
        fileList,
        accept: '.png,.jpg,.jpeg',
        onChange(info) {
            const { status } = info.file;
            if (status === 'uploading') {
                info.file.status = 'done';
            }
            if (status === 'done' || status === 'removed') {
                setFileList(info.fileList);
            }
        },
        onSuccess(res, file) {
            onSave(res?.imageId);
        },
        onError(err) {
            console.log('onError', err);
        },
        customRequest: async ({ file, onSuccess, onError, onProgress }) => {
            let fileList = new FormData();
            fileList.append('image', file);
            fileList.append('fileName', file.name);
            fileList.append('action', 'image-create-application');
            try {
                const onUploadProgress = ({ total, loaded }) => {
                    onProgress(
                        {
                            percent: Math.round((loaded / total) * 100).toFixed(
                                2
                            ),
                        },
                        file
                    );
                };
                const { data } = await GlobalService.uploadImage(
                    fileList,
                    onUploadProgress
                );
                if (data?.resultData?.imageId) {
                    onSuccess(data?.resultData, file);
                    updateIsGenerateDataFlow(false);
                } else {
                    onError('error');
                }
            } catch (error) {
                onError(error);
            }
        },
    };

    const getImage = async (logoId) => {
        try {
            const { data } = await GlobalService.getImage(logoId);
            if (data.resultData?.imageId) {
                setImage(`data:image/png;base64,${data.resultData?.imageId}`);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (dataDiagram?.fileStorageId) getImage(dataDiagram?.fileStorageId);
        else setImage('');
    }, [dataDiagram?.fileStorageId]);

    const handleAction = useCallback(() => {
        switch (action) {
            case 'upload':
                refUpload.current.click();
                break;
            case 'draw':
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/edit-flow`
                );
                break;
            case 'generate':
                if (isNotEnoughData()) {
                    setOpenConfirmClose(true);
                    return;
                }
                updateIsGenerateDataFlow(true);
                break;
            default:
                break;
        }
    }, [action, businessProcessId, isNotEnoughData, updateIsGenerateDataFlow]);

    return (
        <div>
            <div>
                <h1 className="text-[21px] font-bold">
                    {t('Data Flow Diagram')}
                </h1>
                <p>{t('Data Flow Diagram Detail')}</p>
            </div>
            <div className="grid grid-cols-4">
                {!detail?.isGenerateDataFlow && dataDiagram?.lastUpdate ? (
                    <div className="bg-gray-100 w-full rounded-md mb-4 p-4 col-span-3 grid grid-cols-2 gap-4">
                        <div className="flex space-x-4">
                            <div className="font-semibold">
                                {t('Update By')} :
                            </div>
                            <div>{dataDiagram?.updateBy || '-'}</div>
                        </div>
                        <div className="flex space-x-4">
                            <div className="font-semibold">
                                {t('Last Update')} :
                            </div>
                            <div>
                                {dataDiagram?.lastUpdate
                                    ? moment(dataDiagram.lastUpdate).format(
                                          'DD/MM/yyyy HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="col-span-3" />
                )}
               <div className="col-span-1 text-right mt-2 mb-2">
                    <Dropdown menu={{ items }}>
                        <Button
                            hidden={!editMode && isView || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                            type="primary"
                            size="large"
                        >
                            {graphData ||
                            dataDiagram?.fileStorageId ||
                            detail?.isGenerateDataFlow
                                ? t('Change diagram')
                                : t('Add diagram')}
                        </Button>
                    </Dropdown>
                </div>
            </div>
            {!detail?.isGenerateDataFlow && image && (
                <div className="relative text-center">
                    <div className="flex flex-col space-y-2 absolute left-2 top-2 z-10">
                        <Button
                            onClick={() => {
                                let a = document.createElement('a'); //Create <a>
                                a.href = image; //Image Base64 Goes here
                                a.download = 'diagram.png'; //File name Here
                                a.click();
                            }}
                            icon={<DownloadOutlined className="text-purple" />}
                        />
                        <Button
                            hidden={!editMode && isView}
                            onClick={() => setOpenConfirmDelete(true)}
                            danger
                            icon={
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M7.00005 2.18332e-08C7.54895 -7.72662e-05 8.07806 0.205044 8.48348 0.575088C8.8889 0.945132 9.14135 1.45337 9.19125 2H12.6C12.7521 2.00005 12.8984 2.0578 13.0095 2.16158C13.1206 2.26536 13.1881 2.40744 13.1985 2.5591C13.2088 2.71077 13.1612 2.86071 13.0653 2.97864C12.9694 3.09656 12.8322 3.17368 12.6816 3.1944L12.6 3.2H12.1336L11.12 11.984C11.0749 12.3739 10.888 12.7336 10.5949 12.9947C10.3018 13.2558 9.92297 13.4001 9.53045 13.4H4.46965C4.07713 13.4001 3.69828 13.2558 3.40518 12.9947C3.11209 12.7336 2.92519 12.3739 2.88005 11.984L1.86565 3.2H1.40005C1.25506 3.19999 1.11498 3.14749 1.0057 3.05219C0.896433 2.95689 0.825367 2.82524 0.805649 2.6816L0.800049 2.6C0.800055 2.45501 0.852563 2.31493 0.947862 2.20566C1.04316 2.09638 1.17481 2.02532 1.31845 2.0056L1.40005 2H4.80885C4.85875 1.45337 5.11119 0.945132 5.51661 0.575088C5.92203 0.205044 6.45114 -7.72662e-05 7.00005 2.18332e-08ZM5.80005 5C5.60405 5 5.44005 5.124 5.40645 5.2872L5.40005 5.3504V10.2504L5.40645 10.3128C5.44005 10.476 5.60405 10.6 5.80005 10.6C5.99605 10.6 6.16005 10.476 6.19365 10.3128L6.20005 10.2496V5.3512L6.19365 5.2872C6.16005 5.1248 5.99605 5 5.80005 5ZM8.20005 5C8.00405 5 7.84005 5.124 7.80645 5.2872L7.80005 5.3504V10.2504L7.80645 10.3128C7.84005 10.476 8.00405 10.6 8.20005 10.6C8.39605 10.6 8.56005 10.476 8.59365 10.3128L8.60005 10.2496V5.3512L8.59365 5.2872C8.56005 5.1248 8.39605 5 8.20005 5ZM7.00005 1.2C6.51605 1.2 6.11205 1.544 6.02005 2H7.98005C7.88725 1.544 7.48405 1.2 7.00005 1.2Z" />
                                </svg>
                            }
                        />
                    </div>
                    <Image className="w-full" src={image} />
                </div>
            )}
            {detail?.isGenerateDataFlow && (
                <Draw
                    updateIsGenerateDataFlow={updateIsGenerateDataFlow}
                    hiddenButton={!editMode && isView}
                    detail={detail}
                    dataFlowInfo={dataFlowInfo}
                />
            )}
            {!detail?.isGenerateDataFlow && graphData && (
                <XflowComponent viewMode graphData={graphData} />
            )}
            {!image && !graphData && !detail?.isGenerateDataFlow && (
                <div className="h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
            <div className="hidden">
                <Upload {...uploadProps}>
                    <button ref={refUpload}>upload</button>
                </Upload>
            </div>
            <ModalConfirm
                title={t('Change the diagram image')}
                text="การเปลี่ยนแปลงนี้จะแทนที่ภาพ Diagram ล่าสุด หลังจากเลือก upload ภาพใหม่ หรือบันทึกการวาด Diagram"
                open={openImageChange}
                icon={<IconConfirmeWarning />}
                handelOk={() => {
                    if (typeOpen === 'image') {
                        refUpload.current.click();
                    } else {
                        navigate(
                            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/edit-flow`
                        );
                    }
                }}
                handelClose={() => setOpenImageChange(false)}
            />
            <ModalConfirm
                title={t('Change the diagram image')}
                text="การเปลี่ยนแปลงนี้จะแทนที่ภาพ Diagram ล่าสุด หลังจากเลือก generate ภาพใหม่"
                open={openConfirmGenerate}
                icon={<IconConfirmeWarning />}
                handelOk={handleAction}
                handelClose={() => setOpenConfirmGenerate(false)}
            />
            <ModalDelete
                text={t('dataFlow.modalDelete')}
                open={openConfirmDelete}
                handelOk={() => onSave('')}
                handelClose={() => setOpenConfirmDelete(false)}
            />
            <ModalConfirm
                icon={icon}
                title={t('Not enough data to create flow')}
                text={t('Please fill in all information completely')}
                isConfirm={false}
                open={openConfirmClose}
                handelOk={() => setOpenConfirmClose(false)}
                handelClose={() => setOpenConfirmClose(false)}
            />
        </div>
    );
};

const icon = (
    <svg
        width={150}
        height={108}
        viewBox="0 0 150 108"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_540_48181)">
            <path
                d="M117.893 9.71776C117.514 6.949 117.039 3.97632 115.079 1.97761C114.457 1.34342 113.713 0.841276 112.891 0.501456C112.068 0.161636 111.186 -0.00882479 110.296 0.00035175C109.406 0.00952829 108.527 0.198154 107.712 0.554852C106.898 0.911549 106.164 1.42893 105.555 2.07581C104.128 3.5923 103.498 5.72168 103.44 7.79947C103.383 9.87725 103.847 11.932 104.363 13.9462C107.089 14.0004 109.796 13.4697 112.299 12.3899C112.912 12.0916 113.549 11.8427 114.202 11.6456C114.863 11.4779 115.334 11.8999 115.949 12.194L116.287 11.55C116.563 12.0624 117.419 11.9105 117.73 11.4178C118.04 10.9251 117.972 10.2941 117.893 9.71776Z"
                fill="#2F2E41"
            />
            <path
                d="M106.503 21.4081L107.293 17.3898L101.373 14.8364L90.7887 9.78487C90.7149 9.31613 90.5001 8.88074 90.1725 8.53631C89.845 8.19187 89.4202 7.95462 88.9544 7.85593C88.4885 7.75725 88.0036 7.80178 87.5637 7.98363C87.1239 8.16549 86.7498 8.4761 86.4909 8.87438C86.2321 9.27266 86.1007 9.73984 86.1142 10.2141C86.1277 10.6884 86.2854 11.1474 86.5664 11.5305C86.8475 11.9135 87.2386 12.2025 87.6881 12.3593C88.1376 12.5161 88.6243 12.5332 89.0838 12.4084L99.1611 18.6042L106.503 21.4081Z"
                fill="#FFB8B8"
            />
            <path
                d="M102.529 20.7282L106.817 16.3613L106.902 16.387C106.955 16.4031 112.283 18.0212 115.679 19.6654C116.063 19.8371 116.405 20.0901 116.68 20.4068C116.956 20.7236 117.159 21.0964 117.275 21.4993C117.444 22.0634 117.444 22.6645 117.275 23.2286C117.106 23.7928 116.775 24.2955 116.323 24.675C115.859 25.0891 115.285 25.3613 114.669 25.4589C114.053 25.5566 113.423 25.4755 112.852 25.2255L102.529 20.7282Z"
                fill="#7B67FB"
            />
            <path
                d="M102.516 39.9274L114.573 43.1372L117.008 31.7896L105.941 28.377L102.516 39.9274Z"
                fill="#FFB8B8"
            />
            <path
                d="M115.922 36.8474L104.144 34.1488L101.888 28.7027C101.705 27.9253 101.749 27.1118 102.017 26.3589C102.284 25.606 102.763 24.9456 103.397 24.4562L107.7 20.8366L110.007 17.9006L109.756 16.3447C109.711 16.0337 109.776 15.7169 109.941 15.449C110.106 15.181 110.359 14.9788 110.658 14.8772L113.732 13.7788C114.072 13.6521 114.448 13.6589 114.783 13.7977C115.118 13.9366 115.387 14.197 115.537 14.5264L115.863 15.2777C115.863 15.2777 117.253 15.9295 118.037 16.2961C118.44 16.4788 118.8 16.7443 119.094 17.0753C119.387 17.4062 119.607 17.7952 119.739 18.2166C120.938 22.0794 120.615 26.2525 118.834 29.8861L115.922 36.8474Z"
                fill="#7B67FB"
            />
            <path
                d="M11.1734 94.659L5.4784 93.1408C4.64104 90.1712 4.54395 87.0428 5.19558 84.0273C7.68013 88.9203 14.3529 89.8429 18.3058 93.6585C19.5296 94.858 20.4667 96.3164 21.0478 97.9258C21.6288 99.5351 21.8389 101.254 21.6625 102.955L23.0267 106.893C20.2576 106.784 17.5451 106.078 15.0761 104.824C12.6072 103.57 10.4405 101.797 8.72534 99.6287C7.77523 98.4026 6.98387 97.0622 6.36996 95.6391C8.75297 95.2913 11.1734 94.659 11.1734 94.659Z"
                fill="#F2F2F2"
            />
            <path
                d="M81.9255 108.001H26.1072C24.6113 107.999 23.1771 107.406 22.1193 106.352C21.0615 105.299 20.4665 103.87 20.4648 102.379V28.7462C20.4665 27.2559 21.0615 25.8271 22.1193 24.7733C23.1771 23.7195 24.6113 23.1267 26.1072 23.125H81.9255C83.4214 23.1267 84.8556 23.7195 85.9133 24.7733C86.9711 25.8271 87.5661 27.2559 87.5678 28.7462V102.379C87.5661 103.87 86.9711 105.299 85.9133 106.352C84.8556 107.406 83.4214 107.999 81.9255 108.001Z"
                fill="#E6E6E6"
            />
            <path
                d="M60.6225 103.442H30.032C28.6699 103.44 27.3641 102.9 26.401 101.941C25.4378 100.981 24.8961 99.6803 24.8945 98.3233V32.7999C24.8961 31.4429 25.4378 30.142 26.401 29.1824C27.3641 28.2229 28.67 27.6832 30.032 27.6816H78.0031C79.3652 27.6832 80.671 28.2229 81.6342 29.1824C82.5973 30.142 83.1391 31.4429 83.1406 32.7999V81.0079C83.1339 86.9557 80.7592 92.6579 76.5377 96.8636C72.3162 101.069 66.5926 103.435 60.6225 103.442Z"
                fill="white"
            />
            <path
                d="M73.2166 40.261H34.8164C34.652 40.2612 34.4891 40.2291 34.337 40.1666C34.185 40.1041 34.0468 40.0123 33.9304 39.8966C33.814 39.7809 33.7216 39.6435 33.6584 39.4922C33.5953 39.3409 33.5627 39.1787 33.5625 39.0149C33.5623 38.851 33.5945 38.6887 33.6572 38.5373C33.72 38.3858 33.8121 38.2482 33.9282 38.1322C34.0443 38.0162 34.1823 37.9241 34.3342 37.8612C34.486 37.7983 34.6488 37.7658 34.8133 37.7656H73.2166C73.5487 37.7652 73.8674 37.8963 74.1026 38.13C74.3378 38.3636 74.4701 38.6808 74.4705 39.0117C74.4709 39.3426 74.3394 39.6601 74.1048 39.8944C73.8703 40.1287 73.5519 40.2605 73.2197 40.261H73.2166Z"
                fill="#65707A"
            />
            <path
                d="M73.2171 45.1918H34.8169C34.4847 45.1918 34.1662 45.0603 33.9313 44.8263C33.6964 44.5923 33.5645 44.2749 33.5645 43.944C33.5645 43.6131 33.6964 43.2957 33.9313 43.0617C34.1662 42.8277 34.4847 42.6963 34.8169 42.6963H73.2171C73.5492 42.6963 73.8678 42.8277 74.1026 43.0617C74.3375 43.2957 74.4695 43.6131 74.4695 43.944C74.4695 44.2749 74.3375 44.5923 74.1026 44.8263C73.8678 45.0603 73.5492 45.1918 73.2171 45.1918Z"
                fill="#65707A"
            />
            <path
                d="M51.4624 50.1224H34.8169C34.4847 50.1224 34.1662 49.991 33.9313 49.757C33.6964 49.523 33.5645 49.2056 33.5645 48.8747C33.5645 48.5438 33.6964 48.2264 33.9313 47.9924C34.1662 47.7584 34.4847 47.627 34.8169 47.627H51.4624C51.7946 47.627 52.1132 47.7584 52.348 47.9924C52.5829 48.2264 52.7149 48.5438 52.7149 48.8747C52.7149 49.2056 52.5829 49.523 52.348 49.757C52.1132 49.991 51.7946 50.1224 51.4624 50.1224Z"
                fill="#65707A"
            />
            <path
                d="M73.2166 60.4475H34.8164C34.4843 60.4479 34.1656 60.3168 33.9304 60.0832C33.6953 59.8495 33.5629 59.5323 33.5625 59.2014C33.5621 58.8705 33.6936 58.553 33.9282 58.3187C34.1628 58.0844 34.4811 57.9526 34.8133 57.9521H73.2166C73.5487 57.9517 73.8674 58.0828 74.1026 58.3165C74.3378 58.5502 74.4701 58.8674 74.4705 59.1983C74.4709 59.5292 74.3394 59.8467 74.1048 60.081C73.8703 60.3152 73.5519 60.4471 73.2197 60.4475H73.2166Z"
                fill="#E4E4E4"
            />
            <path
                d="M73.2171 65.3783H34.8169C34.4847 65.3783 34.1662 65.2468 33.9313 65.0128C33.6964 64.7788 33.5645 64.4615 33.5645 64.1305C33.5645 63.7996 33.6964 63.4823 33.9313 63.2483C34.1662 63.0143 34.4847 62.8828 34.8169 62.8828H73.2171C73.5492 62.8828 73.8678 63.0143 74.1026 63.2483C74.3375 63.4823 74.4695 63.7996 74.4695 64.1305C74.4695 64.4615 74.3375 64.7788 74.1026 65.0128C73.8678 65.2468 73.5492 65.3783 73.2171 65.3783Z"
                fill="#E4E4E4"
            />
            <path
                d="M51.4624 70.308H34.8169C34.4847 70.308 34.1662 70.1765 33.9313 69.9425C33.6964 69.7085 33.5645 69.3912 33.5645 69.0602C33.5645 68.7293 33.6964 68.4119 33.9313 68.178C34.1662 67.944 34.4847 67.8125 34.8169 67.8125H51.4624C51.7946 67.8125 52.1132 67.944 52.348 68.178C52.5829 68.4119 52.7149 68.7293 52.7149 69.0602C52.7149 69.3912 52.5829 69.7085 52.348 69.9425C52.1132 70.1765 51.7946 70.308 51.4624 70.308Z"
                fill="#E4E4E4"
            />
            <path
                d="M73.2166 80.634H34.8164C34.4843 80.6344 34.1656 80.5034 33.9304 80.2697C33.6953 80.036 33.5629 79.7188 33.5625 79.3879C33.5621 79.057 33.6936 78.7395 33.9282 78.5052C34.1628 78.2709 34.4811 78.1391 34.8133 78.1387H73.2166C73.5487 78.1383 73.8674 78.2693 74.1026 78.503C74.3378 78.7367 74.4701 79.0539 74.4705 79.3848C74.4709 79.7157 74.3394 80.0332 74.1048 80.2675C73.8703 80.5017 73.5519 80.6336 73.2197 80.634H73.2166Z"
                fill="#E4E4E4"
            />
            <path
                d="M73.2171 85.5638H34.8169C34.4847 85.5638 34.1662 85.4324 33.9313 85.1984C33.6964 84.9644 33.5645 84.647 33.5645 84.3161C33.5645 83.9852 33.6964 83.6678 33.9313 83.4338C34.1662 83.1998 34.4847 83.0684 34.8169 83.0684H73.2171C73.5492 83.0684 73.8678 83.1998 74.1026 83.4338C74.3375 83.6678 74.4695 83.9852 74.4695 84.3161C74.4695 84.647 74.3375 84.9644 74.1026 85.1984C73.8678 85.4324 73.5492 85.5638 73.2171 85.5638Z"
                fill="#E4E4E4"
            />
            <path
                d="M51.462 90.4935H34.8164C34.4847 90.4929 34.1667 90.3611 33.9324 90.1272C33.698 89.8933 33.5664 89.5763 33.5664 89.2458C33.5664 88.9153 33.698 88.5983 33.9324 88.3643C34.1667 88.1304 34.4847 87.9987 34.8164 87.998H51.462C51.7937 87.9987 52.1117 88.1304 52.346 88.3643C52.5804 88.5983 52.712 88.9153 52.712 89.2458C52.712 89.5763 52.5804 89.8933 52.346 90.1272C52.1117 90.3611 51.7937 90.4929 51.462 90.4935Z"
                fill="#E4E4E4"
            />
            <path
                d="M107.197 31.4566L104.688 25.8831L104.742 25.8138C104.777 25.7704 108.238 21.4231 111.017 18.8761C111.318 18.583 111.679 18.3589 112.076 18.2193C112.473 18.0796 112.895 18.0279 113.314 18.0677C113.903 18.1176 114.464 18.3377 114.929 18.7009C115.394 19.064 115.743 19.5545 115.932 20.1122C116.149 20.6943 116.193 21.3263 116.059 21.9327C115.925 22.5391 115.619 23.0943 115.176 23.5317L107.197 31.4566Z"
                fill="#7B67FB"
            />
            <path
                d="M109.464 13.1378C112.472 13.1378 114.911 10.7084 114.911 7.71148C114.911 4.7146 112.472 2.28516 109.464 2.28516C106.456 2.28516 104.018 4.7146 104.018 7.71148C104.018 10.7084 106.456 13.1378 109.464 13.1378Z"
                fill="#FFB8B8"
            />
            <path
                d="M101.003 104.113H98.7514L97.6797 95.4609H101.003V104.113Z"
                fill="#FFB8B8"
            />
            <path
                d="M102.191 108H100.577L100.288 106.481L99.5502 108H95.2675C95.0622 108 94.8623 107.935 94.6969 107.814C94.5316 107.693 94.4094 107.522 94.3483 107.327C94.2872 107.131 94.2904 106.922 94.3573 106.728C94.4243 106.535 94.5515 106.368 94.7204 106.252L98.1405 103.899V102.363L101.738 102.577L102.191 108Z"
                fill="#2F2E41"
            />
            <path
                d="M129.224 102.207L127.132 103.037L122.924 95.3926L126.012 94.168L129.224 102.207Z"
                fill="#FFB8B8"
            />
            <path
                d="M131.771 105.381L130.271 105.976L129.439 104.671L129.317 106.354L125.338 107.932C125.148 108.008 124.938 108.021 124.739 107.969C124.54 107.918 124.364 107.804 124.234 107.645C124.105 107.486 124.03 107.29 124.021 107.086C124.011 106.882 124.067 106.68 124.181 106.51L126.485 103.063L125.915 101.636L129.337 100.51L131.771 105.381Z"
                fill="#2F2E41"
            />
            <path
                d="M101.87 100.138H97.2129L98.5001 78.3382L97.5591 63.5615L97.5611 63.5497L101.071 42.3681C101.347 40.6978 102.093 39.1398 103.222 37.8751L103.265 37.8271L115.01 40.7171L116.191 43.3997C120.223 45.7891 121.497 59.2625 121.549 59.8364L123.256 76.6326L127.432 97.218L124.492 98.7954L124.442 98.6978L115.158 80.3058L109.295 60.9102L105.541 78.3666L101.87 100.138Z"
                fill="#2F2E41"
            />
            <path
                d="M116.211 7.966C116.018 6.7047 115.816 5.43283 115.364 4.24519C114.911 3.05755 114.181 1.94514 113.134 1.27236C111.476 0.207171 109.33 0.412608 107.472 1.02533C106.034 1.49919 104.631 2.2194 103.618 3.37727C102.604 4.53515 102.035 6.18731 102.412 7.70127C104.394 7.23463 106.377 6.76799 108.359 6.30134L108.142 6.45412C108.793 6.77749 109.362 7.24436 109.805 7.81928C110.247 8.3942 110.553 9.06207 110.698 9.77219C110.84 10.4909 110.819 11.2321 110.638 11.942C110.457 12.652 110.12 13.313 109.651 13.8772C111.003 13.3994 112.355 12.9215 113.707 12.4437C114.542 12.1488 115.435 11.8089 115.93 11.0524C116.504 10.1753 116.371 9.01273 116.211 7.966Z"
                fill="#2F2E41"
            />
            <path
                d="M0.285547 107.948H149.714C149.79 107.948 149.863 107.918 149.916 107.865C149.97 107.811 150 107.739 150 107.663C150 107.588 149.97 107.516 149.916 107.462C149.863 107.409 149.79 107.379 149.714 107.379H0.285547C0.209814 107.379 0.137187 107.409 0.0836354 107.462C0.0300841 107.516 0 107.588 0 107.663C0 107.739 0.0300841 107.811 0.0836354 107.865C0.137187 107.918 0.209814 107.948 0.285547 107.948Z"
                fill="#CCCCCC"
            />
            <path
                d="M65.8915 40.2941H99.6879C100.015 40.2924 100.335 40.2058 100.619 40.0428C100.902 39.8799 101.139 39.6461 101.306 39.3642C101.472 39.0823 101.564 38.7619 101.571 38.4341C101.578 38.1063 101.5 37.7823 101.345 37.4935L84.4553 5.99878C84.2934 5.69686 84.0531 5.44457 83.7598 5.26871C83.4666 5.09285 83.1313 5 82.7897 5C82.4481 5 82.1128 5.09285 81.8196 5.26871C81.5263 5.44457 81.286 5.69686 81.1241 5.99878L64.226 37.4935C64.0709 37.7829 63.9932 38.1077 64.0005 38.4362C64.0078 38.7647 64.0998 39.0856 64.2676 39.3678C64.4354 39.6499 64.6732 39.8835 64.9578 40.0459C65.2425 40.2083 65.5642 40.2938 65.8915 40.2941ZM84.9401 34.5391H80.6394V30.2249H84.9401V34.5391ZM84.9401 27.3474H80.6394V18.7169H84.9401V27.3474Z"
                fill="#F9C153"
            />
            <path
                d="M109.286 28.021L105.822 25.8184L101.27 30.3727L92.6777 38.3365C92.2129 38.2334 91.7275 38.2733 91.2859 38.4509C90.8443 38.6285 90.4672 38.9355 90.2045 39.3313C89.9419 39.727 89.806 40.1929 89.8149 40.6673C89.8237 41.1417 89.977 41.6022 90.2543 41.988C90.5316 42.3737 90.9199 42.6665 91.3679 42.8275C91.8159 42.9886 92.3024 43.0104 92.763 42.8901C93.2237 42.7697 93.6368 42.5128 93.9478 42.1534C94.2587 41.7941 94.4528 41.3491 94.5044 40.8774L103.98 33.8019L109.286 28.021Z"
                fill="#FFB8B8"
            />
        </g>
        <defs>
            <clipPath id="clip0_540_48181">
                <rect width={150} height={108} fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Tab6;
